import React from 'react';
import { Row, Col, Typography, Flex, Button } from 'antd';
import ArrowButton from '../../../shared/ArrowButton';

import {
  useNavigate,
} from "react-router-dom";
import { getIcon, ICONS } from '../../../icons';
import Paragraph from 'antd/es/typography/Paragraph';

const { Title } = Typography;

const Feature = ( { description, colour } ) => { 
  return ( 
    <Flex
      gap={5}
      align="flex-start"
    >
      { getIcon(ICONS.CHECK, false, {
        primary: colour, 
        secondary: colour, 
        style: { 
          marginTop: 3,
          width: 25
        }
      } ) }
      <div
        style={ {
          width: '100%'
        } }
        >{ description }</div>
    </Flex>
  )
}

const PricingPlan = ({ 
  name, 
  description, 
  featureIntro, 
  features,
  backgroundColour, 
  colour, 
  price
} ) => { 
  const navigate = useNavigate();
  return (
    <Flex
      vertical
      gap={10}
      style={{ 
        width: '100%',
        borderRadius: 15,
        background: backgroundColour,
        color: colour,
        padding: '20px',
        position: 'relative'
      }}
      > 
      <Title level={3}
        style={{ 
          marginTop: 0,
          color: colour
        }}
        >{ name }</Title>
      <Paragraph style={{ color: colour }}>{ description }</Paragraph>
      <Paragraph style={{ color: colour }}>{ featureIntro }</Paragraph>
      <Flex
        vertical
        style={ { marginBottom: 40 }}
        >
      { features.map ( (feature) => { 
        return <Feature 
          colour={ colour }
          description={ feature }/>
      })}
      </Flex>
      <Flex
        style={{ 
          marginTop: 40,
          bottom: 20,
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)"
        }}
        >
        <Title level={5} style={{ color: colour }}>{ price ? `only £${price} / month` : 'Free, forever' }</Title>
      </Flex>
      {/* <Button
        style={{ 
          marginTop: 10,
          bottom: 20,
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)"
        }}
        >Sign Up</Button> */}
    </Flex>
  )
}

export default PricingPlan;